// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2816":"5ee8033b","4810":"11735147","7484":"af1dd8af","7984":"6f725360","8651":"99653911","9781":"f13cb1f7"}[chunkId] + ".chunk.css";
};